module.exports = __webpack_public_path__ + "img/login2.3a49e15f.jpg";